import React, { useState } from "react";
import { useI18n } from "../i18n";
import { useAuth } from "../auth";
import { apiSend, getToken } from "../api";
import { C, R } from "../theme";

// Flag + name language picker. Persists via I18nProvider (localStorage) and,
// for authenticated users, syncs the choice to their profile `language` field.
export default function LanguageSwitcher({ align = "right" }) {
  const { lang, setLang, languages } = useI18n();
  const auth = useAuth();
  const user = auth?.user;
  const [open, setOpen] = useState(false);
  const current = languages.find((l) => l.code === lang) || languages[0];
  const menuPos = align === "center" ? { left: "50%", transform: "translateX(-50%)" } : { [align]: 0 };

  const pick = async (code) => {
    setOpen(false);
    setLang(code);
    if (user && getToken()) {
      try { await apiSend("/auth/language", "PATCH", { language: code }); } catch (e) { /* non-blocking */ }
    }
  };

  return (
    <div data-testid="language-switcher" style={{ position: "relative", display: "inline-block" }}>
      <button data-testid="language-switcher-trigger" className="pressable" onClick={() => setOpen((o) => !o)}
        style={{ display: "inline-flex", alignItems: "center", gap: 8, background: C.card2, border: `1px solid ${C.borderStrong}`, borderRadius: R.pill, padding: "10px 16px", color: C.text, fontWeight: 700, fontSize: 14, cursor: "pointer", minHeight: 44 }}>
        <span style={{ fontSize: 18 }}>{current.flag}</span><span>{current.label}</span>
        <span style={{ color: C.muted, fontSize: 12 }}>▾</span>
      </button>
      {open && (
        <>
          <div onClick={() => setOpen(false)} style={{ position: "fixed", inset: 0, zIndex: 40 }} />
          <div role="menu" style={{ position: "absolute", top: "calc(100% + 6px)", ...menuPos, background: C.card, border: `1px solid ${C.borderStrong}`, borderRadius: R.md, padding: 6, minWidth: 190, zIndex: 50, boxShadow: "0 12px 30px rgba(0,0,0,0.35)" }}>
            {languages.map((l) => (
              <button key={l.code} data-testid={`language-option-${l.code}`} className="pressable" onClick={() => pick(l.code)}
                style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", textAlign: "left", background: l.code === lang ? C.card2 : "transparent", border: "none", borderRadius: R.sm, padding: "10px 12px", color: C.text, fontWeight: l.code === lang ? 800 : 600, fontSize: 15, cursor: "pointer" }}>
                <span style={{ fontSize: 18 }}>{l.flag}</span><span style={{ flex: 1 }}>{l.label}</span>
                {l.code === lang && <span style={{ color: C.amber, fontWeight: 900 }}>✓</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
